// ###### COLOR UTILITIES

// Convert hex color to RGB array
const hexToRgb = (hex) => {
  hex = hex.replace('#', '');
  return {
    r: parseInt(hex.substring(0, 2), 16),
    g: parseInt(hex.substring(2, 4), 16),
    b: parseInt(hex.substring(4, 6), 16)
  };
};

// Mix color with white to create a light tint
// ratio: 0 = full white, 1 = original color
const mixWithWhite = (rgb, ratio = 0.15) => {
  const whiteRatio = 1 - ratio;
  return {
    r: Math.round(rgb.r * ratio + 255 * whiteRatio),
    g: Math.round(rgb.g * ratio + 255 * whiteRatio),
    b: Math.round(rgb.b * ratio + 255 * whiteRatio)
  };
};

// Get light background color from cluster color
// Mixes the cluster color with white (default 8% color, 92% white)
export const getLightBackgroundColor = (clusterColor, ratio = 0.08) => {
  if (!clusterColor) return null;
  
  const rgb = hexToRgb(clusterColor);
  const lightRgb = mixWithWhite(rgb, ratio);
  
  return `rgb(${lightRgb.r}, ${lightRgb.g}, ${lightRgb.b})`;
};
